export const STATUS_OPTIONS = [
  'Para ser contactado/a',
  'Ignorado/a (pedido sem interesse)',
  'Não estava interessado/a',
  'À espera de feedback',
  'Convertido/a em cliente'
];

export const STATUS_COLORS = {
  'Ignorado/a (pedido sem interesse)': 'bg-red-50 text-red-700 border border-red-200',
  'Não estava interessado/a': 'bg-red-50 text-red-700 border border-red-200',
  'Para ser contactado/a': 'bg-amber-50 text-amber-700 border border-amber-200',
  'À espera de feedback': 'bg-amber-50 text-amber-700 border border-amber-200',
  'Convertido/a em cliente': 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  'refunded': 'bg-purple-100 text-purple-700'
};
